import * as actions from "store/actions";

// What is an action
// https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions

// Action Creators
export const brandingElementsFetchedFromServer = (response) => ({
    type: actions.BRANDING_ELEMENTS_FETCHED_FROM_SERVER,
    payload: response,
});

export const brandingElementsSavedToServer = (response) => ({
    type: actions.BRANDING_ELEMENTS_SAVED_TO_SERVER,
    payload: response,
});

export const themeItemUpdated = (storeKey, newValue) => ({
    type: actions.THEME_ITEM_UPDATED,
    payload: { storeKey, newValue },
});

export const chatItemUpdated = (storeKey, newValue) => ({
    type: actions.CHAT_ITEM_UPDATED,
    payload: { storeKey, newValue },
});

export const pwaItemUpdated = (storeKey, newValue) => ({
    type: actions.PWA_ITEM_UPDATED,
    payload: { storeKey, newValue },
});

export const linkItemUpdated = (storeKey, newValue) => ({
    type: actions.LINK_ITEM_UPDATED,
    payload: { storeKey, newValue },
});